module.exports = __webpack_public_path__ + "static/img/helpingHand.66ab3470.png";